export const articles = [
  {
    slug: 'mama-de-guimi-a-yi',
    title: '妈妈的闺蜜阿怡：四十年友情，胜过亲姐妹',
    excerpt: '阿怡阿姨是妈妈从少女时代就认识的朋友。四十年来，她们一起经历了结婚生子、家庭变故、子女成长，始终彼此扶持。妈妈常说，有些话只能跟阿怡说，因为只有她真正懂。',
    content: `<p>阿怡阿姨第一次出现在我家的相册里，是在一张泛黄的黑白照片上。那是1978年的夏天，妈妈和阿怡并肩站在纺织厂的门口，穿着同样的碎花衬衫，扎着两条粗黑的麻花辫，笑得像两朵盛开的向日葵。</p>
<p>妈妈说，那时候她刚满十八岁，从农村来到城市当纺织女工。人生地不熟，第一天上班就弄断了好几根纱线，急得直掉眼泪。是阿怡主动走过来，手把手地教她接线头、调机器，还把自己的午饭分了她一半。</p>
<p>"我第一眼看到阿怡，就觉得这个姑娘特别亲切，笑起来眼睛弯弯的，像月牙儿。"妈妈每次说起这段往事，眼睛里都闪着光。</p>
<p>从那以后，两个人就成了形影不离的好朋友。一起上班，一起吃饭，一起逛街，一起在宿舍里偷偷听邓丽君的磁带。在那个物质匮乏的年代，她们用彼此的陪伴填满了青春所有的空白。</p>
<p>后来，妈妈认识了爸爸，阿怡是第一个知道的。再后来，阿怡也遇到了她的先生，妈妈是她的伴娘。两家人住在同一个小区，孩子们一起长大，逢年过节必定聚在一起，比亲戚还要亲热。</p>
<p>前几年，阿怡的丈夫因病去世了。那段时间，妈妈每天都会去阿怡家，有时候带一碗热汤，有时候什么都不带，就只是坐在她身边，陪她说说话，或者什么都不说，就那样静静地坐着。我去看过她们几次，两个六十多岁的女人坐在阳台上，夕阳把她们的影子拉得很长很长。妈妈握着阿怡的手，像四十年前阿怡握着她的手一样。</p>
<p>"其实好朋友就是这样，"妈妈后来跟我说，"不是要帮对方解决所有的问题，而是在对方最难过的时候，让她知道，有一个人永远站在她身边。"</p>
<p>今年春节，两家人又聚在一起吃年夜饭。阿怡阿姨端起酒杯，对妈妈说："四十多年了，谢谢你一直在我身边。"妈妈笑着回了一句："说什么谢，咱们谁跟谁啊。"然后两个人都红了眼眶。</p>
<p>看着她们，我突然明白了什么叫"一辈子的朋友"。那不是轰轰烈烈的誓言，不是形影不离的陪伴，而是在漫长岁月中，无论发生什么，心里都知道有一个人在。相隔多远都不怕，因为心从来没有分开过。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20elderly%20Chinese%20women%20sitting%20on%20a%20balcony%20at%20sunset%2C%20holding%20hands%2C%20warm%20golden%20light%2C%20nostalgic%20and%20emotional%20atmosphere%2C%20soft%20focus%2C%20cinematic%20photography%2C%20warm%20tone%2C%20peaceful%20mood%2C%20deep%20friendship%2C%20elegant%20composition&width=1200&height=630&seq=article-cover-01&orientation=landscape',
    category: 'mama-yu-guimi',
    author: '小月',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20avatar%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20illustration%20style%2C%20soft%20pastel%20colors%2C%20simple%20flat%20design%2C%20gentle%20expression&width=100&height=100&seq=avatar-01&orientation=squarish',
    date: '2024-12-15',
    readTime: '8分钟',
    tags: ['闺蜜情谊', '四十年友情', '妈妈的故事'],
    featured: true,
    hot: true,
  },
  {
    slug: 'liang-wei-mama-de-xiawu-cha',
    title: '两位妈妈的下午茶：藏在茶杯里的人生智慧',
    excerpt: '每周三下午，妈妈都会和刘阿姨一起喝茶。这看似简单的下午茶时光，却藏着她们半生积累的生活智慧。从子女教育到婆媳关系，从健康养生到夫妻相处，每一杯茶里都有说不完的故事。',
    content: `<p>每周三下午两点，妈妈都会准时出门，去小区门口那家叫"清心阁"的茶馆。那里有她的老姐妹刘阿姨，也有她们雷打不动的下午茶时光。</p>
<p>这个习惯，已经坚持了快十年。从我有记忆起，妈妈就是一个有"仪式感"的人。她常说，生活再忙，也要给自己留一杯茶的时间。</p>
<p>刘阿姨比妈妈大三岁，退休前是一所中学的语文老师，说话温温柔柔的，但每句话都很有分量。妈妈说她第一次见刘阿姨，是在小区的广场舞队伍里。那时候妈妈刚搬到这个城市，谁也不认识，是刘阿姨主动走过来，问她要不要一起去喝茶。</p>
<p>"有时候，朋友就是一杯茶的距离。"妈妈说这话的时候，语气特别笃定。</p>
<p>她们的下午茶很简单，一壶铁观音或者普洱，两碟小点心，有时候是绿豆糕，有时候是桂花糕。但聊的内容，却一点也不简单。</p>
<p>她们聊子女。刘阿姨的儿子在国外工作，一年回来一两次。妈妈说，每次聊到这个话题，刘阿姨的眼眶就有点红，但她从来不在儿子面前说想他，因为"不想给孩子添麻烦"。于是妈妈就听她倾诉，偶尔插一句"孩子们有孩子们的生活"，然后两个人一起沉默片刻，再换个话题。</p>
<p>她们聊健康。谁最近血压高了，谁膝盖又疼了，哪个牌子的钙片效果好，广场舞哪个动作对腰椎好。那些在年轻人看来琐碎的话题，在她们那里却是最实在的关心。</p>
<p>她们也聊过去。聊年轻时候的苦日子，聊带孩子的艰辛，聊那些熬过来的岁月。每次聊到这些，她们都会相视一笑，那笑容里有说不出的释然。</p>
<p>有一次我提前下班回家，路过茶馆，透过玻璃窗看到她们。夕阳从窗外斜斜地照进来，落在她们花白的头发上，像镀了一层金边。两个人面对面坐着，不知道说了什么，同时笑了起来，笑得前仰后合，像两个少女。</p>
<p>那一刻我突然觉得，这就是妈妈们最美好的样子。不是围着灶台转的母亲，不是操心子女的妻子，而是作为她自己——一个有朋友、有生活、有笑声的女人。</p>
<p>现在我也养成了喝茶的习惯。每当忙得焦头烂额的时候，就给自己泡一杯茶，想想妈妈和刘阿姨的下午茶时光。也许有一天，我也会找到自己的"刘阿姨"，在某个下午，喝一杯茶，聊一聊天，然后发现，原来生活可以这么简单又这么美好。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20middle-aged%20Chinese%20women%20drinking%20tea%20at%20a%20traditional%20tea%20house%2C%20afternoon%20sunlight%20streaming%20through%20window%2C%20warm%20and%20peaceful%20atmosphere%2C%20Chinese%20tea%20set%20on%20table%2C%20soft%20golden%20light%2C%20cinematic%20mood%2C%20intimate%20friendship%2C%20elegant%20composition&width=1200&height=630&seq=article-cover-02&orientation=landscape',
    category: 'shenghuo-zhihui',
    author: '安然',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20avatar%20of%20a%20gentle%20Chinese%20woman%20illustration%2C%20warm%20tone%2C%20simple%20flat%20design%2C%20soft%20features&width=100&height=100&seq=avatar-02&orientation=squarish',
    date: '2024-12-10',
    readTime: '7分钟',
    tags: ['下午茶', '生活智慧', '女性友谊'],
    featured: true,
    hot: false,
  },
  {
    slug: 'mama-sishinian-hou-de-zhongfeng',
    title: '妈妈和发小四十年后的重逢：岁月改变了容颜，改不了情谊',
    excerpt: '妈妈五十八岁那年，失联四十年的发小突然打来电话。两个年过半百的女人在电话里哭成了泪人。见面那天，她们紧紧拥抱，仿佛要把四十年的思念都融进这个拥抱里。',
    content: `<p>那天下午，妈妈接到了一个陌生号码的电话。她犹豫了一下才接起来，电话那头传来一个有点陌生又有点熟悉的声音："小兰，是你吗？我是秀英啊。"</p>
<p>妈妈愣了好几秒，然后眼泪就下来了。</p>
<p>秀英阿姨是妈妈小时候的邻居，也是她童年最要好的玩伴。两个人从幼儿园就在一起，一起上学，一起跳皮筋，一起在夏天的夜晚捉萤火虫。妈妈说她小时候胆子小，每次被别的孩子欺负了，都是秀英站出来帮她。</p>
<p>后来，秀英阿姨家里出了变故，一家人突然搬走了。在那个没有手机、没有微信的年代，搬一次家就意味着彻底的失联。妈妈找了很多人打听秀英的消息，但都没有结果。</p>
<p>这一别，就是整整四十年。</p>
<p>秀英阿姨说，她这些年一直在找妈妈。她记得妈妈的名字，记得妈妈老家的地址，但城市变化太大了，老房子早就拆了。她托人问过，去派出所查过，都没有消息。直到最近，她在网上看到了一篇关于她们小时候住的那条老街的文章，在评论区里有人提到了妈妈的名字。</p>
<p>"我看到你的名字的时候，手都在抖。"秀英阿姨在电话里说，"我想，会不会就是你呢？会不会就是我的小兰呢？"</p>
<p>她们约好了在以前老街的位置见面。那条街早就不在了，变成了一座购物中心。两个年过半百的女人站在商场门口，一眼就认出了彼此。</p>
<p>妈妈后来跟我说，秀英的样子变了很多，头发白了，脸上有了皱纹，身材也发福了。但是那双眼睛没有变，还是小时候那双亮晶晶的、总是在保护她的眼睛。</p>
<p>她们抱在一起哭了好久。路过的人都回头看她们，但她们完全不在乎。</p>
<p>那天下午，她们在商场里的咖啡厅坐了很久，从下午两点一直聊到晚上九点。聊小时候的事，聊各自的家庭，聊这四十年来错过的一切。她们发现，虽然四十年没见，但很多东西都没变——秀英还是那么爽朗，妈妈还是那么温柔。</p>
<p>"真正的朋友，即使分开了四十年，再见面的时候，还是能一眼认出彼此的灵魂。"妈妈这样总结那次重逢。</p>
<p>现在，她们每周都会视频通话，逢年过节互相寄特产。去年国庆，秀英阿姨带着全家来我们家住了三天。看着两个白发苍苍的"老小孩"在厨房里边做饭边聊天，我想，这大概就是友情最美的样子——无论相隔多远，无论分别多久，心永远在一起。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20elderly%20Chinese%20women%20embracing%20warmly%20on%20a%20city%20street%2C%20tears%20of%20joy%2C%20reunion%20after%20many%20years%2C%20autumn%20leaves%20in%20background%2C%20warm%20golden%20afternoon%20light%2C%20emotional%20and%20touching%20scene%2C%20cinematic%20photography&width=1200&height=630&seq=article-cover-03&orientation=landscape',
    category: 'suiyue-gushi',
    author: '小月',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20avatar%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20illustration%20style%2C%20soft%20pastel%20colors%2C%20simple%20flat%20design%2C%20gentle%20expression&width=100&height=100&seq=avatar-01&orientation=squarish',
    date: '2024-11-28',
    readTime: '8分钟',
    tags: ['久别重逢', '发小', '四十年友谊'],
    featured: true,
    hot: true,
  },
  {
    slug: 'women-mama-bu-ganmao',
    title: '原来我们的妈妈，才是真正不感冒的超级英雄',
    excerpt: '小时候觉得妈妈什么都会，长大后才发现，那些"什么都会"的背后，是一个女人默默扛起一切的坚韧。而妈妈的朋友们，就是支撑她的力量之一。',
    content: `<p>在我的记忆里，妈妈好像从来不会生病。</p>
<p>小时候我发烧，妈妈整夜不睡地守在我床边，用湿毛巾给我擦额头，每隔一个小时量一次体温。第二天早上，我退烧了，妈妈又若无其事地去厨房做早饭，然后去上班。</p>
<p>我一直以为妈妈的身体特别好，好到百毒不侵。</p>
<p>直到去年冬天，妈妈因为肺炎住院了。我去医院看她的时候，隔壁床的阿姨正握着她的手，给她削苹果。那位阿姨姓周，是妈妈在社区老年大学认识的朋友。</p>
<p>"你妈啊，就是太要强了。"周阿姨一边削苹果一边跟我说，"上个星期她就有点咳嗽，我说陪她来医院看看，她非说没事没事。结果拖成了肺炎。"</p>
<p>周阿姨说，妈妈在社区大学里学书法，写得特别好，老师经常表扬她。她们一群老姐妹每星期上完课都要一起去吃小笼包，聊聊天，说说笑。</p>
<p>"你妈总说你是她的骄傲，"周阿姨看着我，"说你工作好，又孝顺。每次说到你，她眼睛都发光。"</p>
<p>我的鼻子突然就酸了。</p>
<p>妈妈也总跟我说周阿姨的事。说周阿姨做的红烧肉特别好吃，说周阿姨的孙子特别可爱，说周阿姨上次唱歌比赛拿了一等奖。我以前都是边刷手机边听，左耳进右耳出。现在想起来，那些我以为琐碎的日常，其实是妈妈最真实的生活。</p>
<p>原来，妈妈不是超级英雄。她也会生病，也会脆弱，也会需要朋友的陪伴。只是在我面前，她习惯了扮演那个无所不能的角色。</p>
<p>出院那天，周阿姨和另外几个阿姨一起来接妈妈。她们带了保温桶，里面装着热腾腾的鸡汤。妈妈坐在轮椅上，被一群老姐妹围着，笑得像个小女孩。</p>
<p>那一刻我忽然觉得，妈妈的朋友们，才是她真正的"超能力"。她们让她在不再是别人的"妈妈"、别人的"妻子"的时候，还能做回自己——一个有朋友、有快乐、有烦恼的普通女人。</p>
<p>那天晚上，我给妈妈发了一条微信："妈，以后有事别自己扛，跟我说，也跟阿姨们说。你不是一个人。"</p>
<p>妈妈回了我一个笑脸，和一个"好的"。</p>
<p>我知道她还是会自己扛。但至少，她有一群好姐妹，可以在她需要的时候，递上一个苹果，端来一碗鸡汤，或者什么都不做，就只是陪在她身边。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20group%20of%20elderly%20Chinese%20women%20gathering%20around%20a%20hospital%20bed%2C%20one%20woman%20in%20bed%20smiling%2C%20others%20bringing%20food%20and%20caring%2C%20warm%20atmosphere%2C%20soft%20window%20light%2C%20touching%20moment%20of%20friendship%2C%20cinematic%20scene&width=1200&height=630&seq=article-cover-04&orientation=landscape',
    category: 'qinggan-gongming',
    author: '安然',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20avatar%20of%20a%20gentle%20Chinese%20woman%20illustration%2C%20warm%20tone%2C%20simple%20flat%20design%2C%20soft%20features&width=100&height=100&seq=avatar-02&orientation=squarish',
    date: '2024-11-20',
    readTime: '6分钟',
    tags: ['母女关系', '妈妈的坚强', '情感共鸣'],
    featured: false,
    hot: true,
  },
  {
    slug: 'jie-mei-tuan-de-qiu-you',
    title: '姐妹团的秋游日记：六十岁，人生才刚刚开始',
    excerpt: '妈妈和她五个老姐妹组了一个"秋游团"，每年秋天都要出去旅行一次。她们穿一样的丝巾，拍一样的姿势，笑得比谁都灿烂。她们说，六十岁才是女人最好的年纪。',
    content: `<p>每年十月，妈妈就会变得特别兴奋。因为这是她们"姐妹团"一年一度的秋游时间。</p>
<p>这个"姐妹团"一共六个人，都是妈妈在社区老年大学认识的朋友。年龄最大的六十五岁，最小的五十八岁。她们给自己起了一个特别响亮的名字——"不老松姐妹团"。</p>
<p>去年她们去了云南，在大理的洱海边拍了一组照片。照片里，六个阿姨穿着同款的红色丝巾，手臂挽着手臂，站在蓝天白云下，笑得肆意张扬。那张照片被她们做成了手机壁纸，逢人就给人看。</p>
<p>妈妈把照片发给我的时候，我正被一个项目搞得焦头烂额。看着照片里妈妈灿烂的笑容，我突然有点嫉妒——她活得比我开心多了。</p>
<p>今年她们计划去西安。出发前两周，妈妈就开始准备了。买了新的运动鞋，研究了各种西安美食攻略，还专门去烫了个头。刘阿姨负责订酒店，周阿姨负责做攻略，赵阿姨负责准备药品和急救包。六个人各司其职，配合得天衣无缝。</p>
<p>"你比你妈差远了，"爸爸打趣我说，"你妈她们组织一次秋游，比你们公司做项目还专业。"</p>
<p>我居然无言以对。</p>
<p>她们在西安玩了五天。去了兵马俑、大雁塔、回民街。每天晚上，妈妈都会在群里发照片和视频。有时候是她们在古城墙下骑自行车的画面，有时候是她们在美食街举着肉夹馍自拍。</p>
<p>最让我感动的一张照片，是她们在华山脚下的合影。六个阿姨站成一排，每个人都举着手，比着胜利的V字。夕阳把她们的脸照得红扑扑的。照片配的文字是："不老松姐妹团——第六次秋游圆满成功！"</p>
<p>我想起妈妈以前跟我说过，她年轻的时候从来没有出去旅游过。那时候家里穷，后来又忙着带孩子，哪里有时间、有闲钱出去玩。直到五十多岁，孩子们都大了，她才开始过属于自己的生活。</p>
<p>"妈妈的前半辈子给了我们，"弟弟说，"后半辈子该还给她自己了。"</p>
<p>是啊，看着妈妈和她的姐妹们满世界地跑，我觉得这才是生活该有的样子。不是坐在家里等着老的到来，而是带着一颗不老的心，去拥抱这个广阔的世界。</p>
<p>前两天，妈妈在群里宣布明年的秋游计划——她们要去新疆。群里瞬间炸了锅，阿姨们七嘴八舌地讨论，热闹得像一群要去春游的小学生。</p>
<p>我笑着退出了群聊。心里想的是：妈妈，去疯吧，去野吧，去成为你想成为的人。你永远是我心中最酷的女人。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20group%20of%20six%20elderly%20Chinese%20women%20traveling%20together%20at%20a%20scenic%20mountain%20viewpoint%2C%20wearing%20colorful%20scarves%2C%20laughing%20and%20posing%20for%20photo%2C%20autumn%20colors%20in%20background%2C%20joyful%20atmosphere%2C%20bright%20sunlight%2C%20cinematic%20travel%20photography&width=1200&height=630&seq=article-cover-05&orientation=landscape',
    category: 'rensheng-ganwu',
    author: '雨桐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20avatar%20of%20a%20warm%20Chinese%20girl%20illustration%2C%20round%20face%2C%20gentle%20smile%2C%20soft%20colors%2C%20simple%20flat%20design&width=100&height=100&seq=avatar-03&orientation=squarish',
    date: '2024-11-12',
    readTime: '7分钟',
    tags: ['旅行', '姐妹团', '人生感悟'],
    featured: true,
    hot: false,
  },
  {
    slug: 'mama-shengri-shang-de-mimi',
    title: '妈妈生日宴上的秘密：闺蜜才知道的少女心事',
    excerpt: '妈妈六十岁生日那天，阿姨们偷偷准备了一个惊喜。她们翻出了妈妈少女时代的日记，上面写满了她十七岁的梦想。那一天我才知道，原来妈妈也曾是一个有梦的少女。',
    content: `<p>妈妈六十岁生日那天，我们在酒店给她办了一个生日宴。亲戚朋友来了很多，气氛热闹极了。</p>
<p>重头戏是切蛋糕环节。但就在妈妈准备吹蜡烛的时候，周阿姨突然站了起来，手里拿着一本泛黄的小本子。</p>
<p>"等一下！"周阿姨笑着走到妈妈面前，"在切蛋糕之前，我要给大家念一段东西。"</p>
<p>妈妈看到那个本子，脸一下子红了。"周姐！你从哪里翻出来的！快还给我！"</p>
<p>但周阿姨已经打开了本子，清了清嗓子，开始念：</p>
<p>"今天在街上看到一个女孩穿着红色的连衣裙，太好看了。我以后一定要挣钱买一条红裙子，在大街上转三圈，让所有人都看到我。"</p>
<p>全场哄堂大笑。妈妈捂着脸，耳朵根都红了。</p>
<p>那是妈妈的日记。十七岁的妈妈写的日记。</p>
<p>周阿姨接着念："今天秀兰说她要考大学，我也想考。但是爸妈说女孩子读太多书没用。我偏不信。我要证明给他们看，女孩子也可以有出息。"</p>
<p>笑声渐渐安静了下来。大家都认真地听着。</p>
<p>"今天他看了我一眼！就一眼！但我觉得天都亮了！他一定不知道我是谁，但我已经把他的名字写满了整张草稿纸。我太没出息了，可是我真的好喜欢他啊！"</p>
<p>"他"是我爸爸。妈妈写在日记里的那个男孩，后来真的成了她的丈夫。虽然他们现在天天拌嘴，但我知道，妈妈看爸爸的眼神，和十七岁时一样。</p>
<p>周阿姨继续念了很多段。有关于梦想的，关于友情的，关于爱情的。每一段都是妈妈少女时代的真实记录。那些文字稚嫩而热烈，带着一个十七岁女孩对世界全部的好奇和渴望。</p>
<p>念完后，周阿姨把日记本递给妈妈，说："小兰，不管你现在多少岁，在我们心里，你永远是那个想穿红裙子的小女孩。生日快乐。"</p>
<p>妈妈接过日记本，眼泪大颗大颗地往下掉。她抱着周阿姨，哭着说："谢谢你们，谢谢你们还记得我的红裙子。"</p>
<p>后来我问妈妈，为什么感动成那样。妈妈说："因为只有她们，还记得我是谁。"</p>
<p>她说的"谁"，是那个没有被"母亲"、"妻子"这些身份覆盖的、最本真的自己。</p>
<p>那天晚上回到家，我在网上给妈妈买了一条红裙子。不是让她去大街上转三圈，只是想告诉她——妈妈，不管几岁，你都有做梦的权利。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=An%20elderly%20Chinese%20woman%20at%20a%20birthday%20party%20receiving%20a%20red%20dress%20as%20gift%2C%20surrounded%20by%20female%20friends%2C%20warm%20candlelight%2C%20tears%20of%20joy%2C%20nostalgic%20atmosphere%2C%20birthday%20cake%20on%20table%2C%20cinematic%20indoor%20scene&width=1200&height=630&seq=article-cover-06&orientation=landscape',
    category: 'qinggan-gongming',
    author: '雨桐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20avatar%20of%20a%20warm%20Chinese%20girl%20illustration%2C%20round%20face%2C%20gentle%20smile%2C%20soft%20colors%2C%20simple%20flat%20design&width=100&height=100&seq=avatar-03&orientation=squarish',
    date: '2024-10-28',
    readTime: '7分钟',
    tags: ['少女时代', '妈妈日记', '生日惊喜'],
    featured: true,
    hot: true,
  },
  {
    slug: 'liang-ge-mama-de-gushi',
    title: '两个单亲妈妈的抱团取暖：最苦的日子里，我们互为铠甲',
    excerpt: '张阿姨和李阿姨都是单亲妈妈，各自拉扯着一个孩子。在最艰难的那几年，她们互相帮衬、互相支撑。如今孩子们都长大成人，她们的友情也成了两个家庭最珍贵的财富。',
    content: `<p>张阿姨和李阿姨的故事，是妈妈讲给我听的。她说，这两个人让她看到了什么叫"患难见真情"。</p>
<p>张阿姨的丈夫在她三十三岁那年因车祸去世了，留下她和一个五岁的儿子。李阿姨的情况更复杂一些，丈夫出轨离婚，她一个人带着女儿搬出来，几乎净身出户。</p>
<p>她们住在同一个小区，孩子上同一所幼儿园。刚开始只是接送孩子时碰面打个招呼，后来慢慢熟悉起来，才知道彼此的处境。</p>
<p>"我们就像冬天里的两只刺猬，"张阿姨说，"靠得太近会扎到对方，但离得太远又会冻死。"</p>
<p>她们选择靠在一起。不是刺猬那种带刺的靠近，而是彼此温暖的拥抱。</p>
<p>最艰难的时候，张阿姨的儿子发高烧住院，她请不了假，是李阿姨去医院陪了三天三夜。李阿姨的女儿学校要开家长会，她那天正好有一个重要的面试，是张阿姨替她去的。她们轮流接送两个孩子，一起买菜做饭，把自己做多的菜给对方送一份。过年的时候，两家人合在一起过，四个人的年夜饭，不算丰盛，但温馨极了。</p>
<p>"那时候我们什么都没有，"李阿姨说，"但有彼此。"</p>
<p>后来，张阿姨遇到了现在的丈夫。李阿姨比张阿姨还紧张，专门去"审查"了那个男人好几次，确认他是真心对张阿姨好，才放下心来。张阿姨再婚那天，李阿姨哭得比谁都厉害，她说："我不是难过，我是高兴。你终于有好日子过了。"</p>
<p>再后来，两个孩子都考上了大学。一个在南京，一个在广州。送走孩子那天，两个妈妈在火车站抱头痛哭。路人都以为她们怎么了，只有她们自己知道——这些年的苦，只有对方最懂。</p>
<p>现在，两个孩子都工作了。每年的母亲节，他们都会给两位"妈妈"一起送礼物，因为在他们心里，早就把彼此的妈妈当成了自己的第二个妈妈。</p>
<p>妈妈讲完这个故事，沉默了很久。然后她说了一句让我至今难忘的话：</p>
<p>"女人之间的情谊，有时候比爱情更坚固。爱情会变，但好的姐妹情，是岁月打磨出来的钻石，只会越来越闪亮。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20single%20Chinese%20mothers%20sitting%20together%20in%20a%20modest%20apartment%2C%20supporting%20each%20other%2C%20warm%20evening%20light%20through%20window%2C%20emotional%20and%20touching%20scene%2C%20strength%20and%20resilience%2C%20cinematic%20photography%2C%20soft%20warm%20tones&width=1200&height=630&seq=article-cover-07&orientation=landscape',
    category: 'mama-yu-guimi',
    author: '小月',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20avatar%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20illustration%20style%2C%20soft%20pastel%20colors%2C%20simple%20flat%20design%2C%20gentle%20expression&width=100&height=100&seq=avatar-01&orientation=squarish',
    date: '2024-10-15',
    readTime: '7分钟',
    tags: ['单亲妈妈', '抱团取暖', '患难真情'],
    featured: false,
    hot: true,
  },
  {
    slug: 'cai-shi-chang-li-de-you-qing',
    title: '菜市场里的友情：一把青菜，二十年的交情',
    excerpt: '妈妈和卖菜的陈阿姨认识了二十年。从最初的主顾关系，到后来的知心好友。一把青菜、几句家常，菜市场里的烟火气里，藏着最朴素也最温暖的人情。',
    content: `<p>每个星期六早上七点，妈妈都会准时出现在小区后面的菜市场。她不是去买菜那么简单——她是去见她的老姐妹，卖菜的陈阿姨。</p>
<p>陈阿姨今年六十三岁，在菜市场卖菜卖了二十多年。她嗓门大，性格爽朗，方圆十米都能听到她的笑声。妈妈的菜篮子是红色的，每次远远地出现在菜市场的入口，陈阿姨就会扯着嗓子喊："红篮子来啦！给你留了最好的小白菜！"</p>
<p>妈妈和陈阿姨的交情，是从一把空心菜开始的。</p>
<p>那是二十年前的一个夏天，妈妈刚搬到这个小区，第一次去菜市场买菜。她看中了一把空心菜，准备付钱的时候才发现忘了带钱包。那时候还没有手机支付，妈妈尴尬得不行。陈阿姨看了一眼，说："没事，先拿回去吃，下次来再给。"</p>
<p>妈妈第二天就专门去还了钱，还多带了一个自己做的包子给陈阿姨。从那以后，她们就慢慢熟了起来。</p>
<p>妈妈知道了陈阿姨的丈夫有慢性病，干不了重活，家里全靠她一个人撑着。陈阿姨也知道了妈妈带着两个孩子不容易，每天早上五点就要起来做早饭。</p>
<p>她们就这样，在两个女人的互相理解中，成了朋友。</p>
<p>陈阿姨的菜总是给妈妈最好的、最便宜的。妈妈过意不去，就经常做多了菜给陈阿姨带一份。陈阿姨的孙子满月，妈妈包了一个大红包。妈妈生病住院，陈阿姨每天收摊后都去医院看她，每次都不空手，带一把新鲜的菜，或者几个水果。</p>
<p>"你妈和那个卖菜的阿姨，比亲姐妹还亲。"爸爸有时候会这样打趣妈妈。</p>
<p>今年年初，菜市场要拆迁了。陈阿姨准备回老家养老。走的前一天，妈妈去菜市场找她。陈阿姨给妈妈装了一大袋子菜——都是妈妈爱吃的。两个人就站在那个即将拆迁的菜市场门口，说了很久很久的话。</p>
<p>"以后买菜可没人给你挑最好的了。"陈阿姨笑着说，但眼睛红了。</p>
<p>"那我就少买点，省得买到不好的浪费。"妈妈也笑着说，声音有点颤。</p>
<p>陈阿姨走后，妈妈好长一段时间都不太适应。每个星期六早上还是会习惯性地走到菜市场的方向，走到一半才想起来，那里已经不在了，陈阿姨也不在了。</p>
<p>值得高兴的是，她们现在还经常视频通话。陈阿姨在老家种了几亩菜地，说等秋天丰收了，要给妈妈寄一箱自己种的菜。妈妈说，那她得赶紧去学做泡菜，等陈阿姨的菜来了，做成泡菜再寄回去。</p>
<p>我想，这就是最朴素也最真挚的友情吧——不需要花言巧语，不需要轰轰烈烈，只要心里有彼此，相隔千里也像在身边。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=An%20elderly%20Chinese%20woman%20vegetable%20vendor%20at%20a%20traditional%20wet%20market%2C%20smiling%20warmly%2C%20fresh%20green%20vegetables%20on%20display%2C%20morning%20light%2C%20nostalgic%20atmosphere%2C%20everyday%20warmth%2C%20documentary%20style%20photography&width=1200&height=630&seq=article-cover-08&orientation=landscape',
    category: 'suiyue-gushi',
    author: '安然',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20avatar%20of%20a%20gentle%20Chinese%20woman%20illustration%2C%20warm%20tone%2C%20simple%20flat%20design%2C%20soft%20features&width=100&height=100&seq=avatar-02&orientation=squarish',
    date: '2024-10-05',
    readTime: '7分钟',
    tags: ['菜市场', '平凡友情', '生活故事'],
    featured: false,
    hot: false,
  },
  {
    slug: 'yi-tong-xian-hua-de-ba-shi-sui',
    title: '一束鲜花里的八十岁：妈妈和她闺蜜的浪漫约定',
    excerpt: '妈妈的闺蜜王阿姨有个习惯：每个月给自己买一束鲜花。这个习惯坚持了三十年。她说，这是她和妈妈年轻时候的约定——无论生活多苦，都要给自己留一点浪漫。',
    content: `<p>王阿姨家的餐桌上，永远有一束鲜花。有时候是玫瑰，有时候是百合，有时候是一大把金黄色的向日葵。</p>
<p>这个习惯，她坚持了整整三十年。</p>
<p>"这是我和你妈妈年轻时候的约定。"王阿姨一边修剪花枝一边跟我说，"那时候我们都在纺织厂上班，一个月工资才几十块钱。有一天路过花店，看着橱窗里的玫瑰花，你妈说了一句：'等以后有钱了，我每个月都要买一束花放在家里。'"</p>
<p>"后来呢？"</p>
<p>"后来你妈结了婚，生了孩子，钱都花在你们身上了。但她没有忘记那个约定，每年我生日的时候，她都会送我一束花。我呢，就自己买，每个月都买，替你妈妈把这个约定坚持下去。"</p>
<p>王阿姨今年八十岁了，头发全白了，但精神很好，说话的时候声音洪亮。妈妈走了快五年了，但王阿姨依然每个月雷打不动地给自己买一束花。</p>
<p>"你妈最喜欢玫瑰，尤其是那种深红色的。所以我每个月至少买一次红玫瑰，放在她的照片前面，让她看看——你看，我们的约定，我一直都记得。"</p>
<p>我的喉咙有点紧。</p>
<p>王阿姨拿出了一本相册，里面夹着很多干花花瓣。每一片花瓣下面都标注了日期。"这是2018年3月的玫瑰，这是2019年9月的百合，这是2020年春节的水仙……"她一张一张地翻着，像在翻一本关于友情的编年史。</p>
<p>"你妈走了以后，很长一段时间，我都不想买花了。"王阿姨的声音低了下来，"但后来我想，如果连花都不买了，那个约定就真的断了。你妈在天上看着呢，我不能让她失望。"</p>
<p>那天离开王阿姨家的时候，她送了我一束粉色的康乃馨。"你拿着，就当是你妈妈送你的。"</p>
<p>我抱着那束花走在街上，眼泪止不住地流。不是因为悲伤，而是因为感动——感动于在这个世界上，有一种友情可以跨越生死，可以通过一束花，一直延续下去。</p>
<p>现在我也养成了买花的习惯。每个月的第一天，我都会买一束红玫瑰，放在妈妈的相框旁边。我知道她在天上能看到，也知道王阿姨说的对——有些约定，是永远不会断的。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=An%20elderly%20Chinese%20woman%20holding%20a%20bouquet%20of%20red%20roses%2C%20sitting%20by%20a%20window%2C%20soft%20morning%20light%2C%20nostalgic%20and%20touching%20atmosphere%2C%20photo%20frame%20on%20table%2C%20warm%20tone%2C%20cinematic%20photography%2C%20elegant%20and%20emotional&width=1200&height=630&seq=article-cover-09&orientation=landscape',
    category: 'qinggan-gongming',
    author: '雨桐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20avatar%20of%20a%20warm%20Chinese%20girl%20illustration%2C%20round%20face%2C%20gentle%20smile%2C%20soft%20colors%2C%20simple%20flat%20design&width=100&height=100&seq=avatar-03&orientation=squarish',
    date: '2024-09-20',
    readTime: '6分钟',
    tags: ['约定', '鲜花', '跨越生死'],
    featured: true,
    hot: true,
  },
  {
    slug: 'mama-men-de-yue-xia-wu-hui',
    title: '妈妈们的广场舞江湖：不只是一支舞那么简单',
    excerpt: '别人笑妈妈跳广场舞太土，我却看到了一个属于她们的"江湖"。在那里，有规则、有义气、有排位，还有一个女人在退休后重新找到的自我价值。',
    content: `<p>如果让我用一个词来形容妈妈和她的朋友们，那就是"江湖"。</p>
<p>是的，广场舞江湖。</p>
<p>你也许觉得这很可笑。一群穿着花花绿绿衣服的大妈，在公园里、广场上扭来扭去，有什么好看的？但如果你真正走近她们，你会发现，那里有一个完整的世界。</p>
<p>妈妈在这个江湖里的地位不低——她是领舞之一。为了这个位置，她付出了很多努力。每天晚上七点半，雷打不动地去广场。即使在冬天零下十度的夜晚，她也会穿上厚厚的羽绒服，戴上手套，准时出现在她的位置上。</p>
<p>舞队里有三十多个人，大部分是退休的阿姨。她们给舞队起名叫"夕阳美"，每天都要排练，还有固定的演出日程。谁家有喜事请她们去跳，她们就穿上统一的演出服，浩浩荡荡地出发。</p>
<p>在这个江湖里，每个人都有自己的角色。妈妈是领舞，负责教新动作。刘阿姨管服装，谁的演出服破了、脏了，都是她来处理。周阿姨是"外联部长"，谁家要请舞蹈队，都先找她联系。还有专门管音乐的、管财务的、管后勤的——麻雀虽小，五脏俱全。</p>
<p>但江湖嘛，怎么可能没有纷争。去年就有一个新来的阿姨，不服妈妈的领舞位置，在背后说了几次坏话。妈妈知道以后也没说什么，只是每天更加认真地练舞。后来那个阿姨自己不好意思，主动来找妈妈道歉，两个人现在反而成了好朋友。</p>
<p>"你妈在广场舞队里，比在公司里还忙。"爸爸有时候会抱怨。</p>
<p>但我理解妈妈。工作了一辈子，退休以后最怕的不是没有钱，而是没有价值感。在广场舞队里，她是被需要的，是被尊重的，是有存在感的。这种感觉，是多少退休金都换不来的。</p>
<p>去年夏天，广场舞队参加市里的比赛，拿了一个二等奖。妈妈捧着奖杯回家的时候，笑得像个孩子。那天晚上她发了一条朋友圈："感谢我的姐妹们，有你们真好。"配图是三十多个阿姨在舞台上的大合影，每个人都笑得无比灿烂。</p>
<p>我突然理解了，广场舞对她们来说，不是消磨时间的方式，而是一种生活的仪式感。在这个江湖里，她们不是谁的母亲、谁的妻子、谁的外婆——她们是她们自己，是一群有情有义、敢爱敢恨的女人。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20group%20of%20elderly%20Chinese%20women%20dancing%20together%20in%20a%20park%20square%20at%20sunset%2C%20colorful%20dance%20costumes%2C%20energetic%20and%20joyful%2C%20warm%20golden%20evening%20light%2C%20community%20gathering%2C%20vibrant%20atmosphere%2C%20documentary%20style&width=1200&height=630&seq=article-cover-10&orientation=landscape',
    category: 'rensheng-ganwu',
    author: '小月',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20avatar%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20illustration%20style%2C%20soft%20pastel%20colors%2C%20simple%20flat%20design%2C%20gentle%20expression&width=100&height=100&seq=avatar-01&orientation=squarish',
    date: '2024-09-10',
    readTime: '6分钟',
    tags: ['广场舞', '退休生活', '女性社群'],
    featured: false,
    hot: false,
  },
  {
    slug: 'mama-de-shou-ji-tong-xun-lu',
    title: '妈妈手机通讯录里的那些名字，每一个都是一段人生',
    excerpt: '有一次帮妈妈清理手机，看到她的通讯录。那些备注名让我愣住了——"会做红烧肉的小刘"、"帮我带过孩子的王姐"、"老公同学的妈妈李阿姨"。每一个名字背后，都是一段鲜活的情谊。',
    content: `<p>那天妈妈的手机坏了，让我帮她看看。摆弄了一会儿，问题不大，就是存储空间满了。我帮她清理的时候，无意中看到了她的通讯录。</p>
<p>那是一个完全不同于我的通讯录的世界。</p>
<p>我的通讯录里，存的都是人名，简洁明了。但妈妈的通讯录不一样——</p>
<p>"会做红烧肉的小刘"——这是刘阿姨，她和妈妈在烹饪班认识的，经常交流做菜心得。妈妈的拿手菜糖醋排骨，就是跟她学的。</p>
<p>"帮我带过孩子的王姐"——这是王阿姨，当年我小的时候，爸爸出差、妈妈加班，就是王阿姨帮忙带了我整整一个暑假。</p>
<p>"老公同学的妈妈李阿姨"——这是我同学小明的妈妈。因为我和小明是好朋友，两个妈妈也成了好朋友。虽然我和小明已经很多年没联系了，但她们还经常一起约着逛街。</p>
<p>"会修水管的小赵"——这是社区物业的赵师傅的老婆。有一年冬天水管冻裂了，赵师傅来修，赵太太也跟着来了，帮妈妈收拾了半天的水。后来她们就成了朋友。</p>
<p>我一个个往下翻，一个个备注看过去。每一个备注名，都不是一个简单的"名字"，而是一段故事的标题。这些故事串联起来，就是妈妈这六十多年的人生。</p>
<p>我还发现了一个特别的备注组，叫"老姐妹"。点开一看，里面有二十多个联系人。每个人的备注名后面都加了一个括号，写着她们认识的年份——"小芳（1978）"、"秀英（1975）"、"阿怡（1978）"……年份跨度从1975年到2020年。</p>
<p>我这才意识到，妈妈的社交网络，比我想象的要丰富得多。不是那种微信好友几千个的表面繁荣，而是一个个真实的人，一段段真实的情谊。</p>
<p>那天晚上我拿着手机问妈妈，能不能给我讲讲这些人的故事。妈妈眼睛一亮，一个个给我讲了起来。讲了一个多小时，还意犹未尽。</p>
<p>我才发现，我对妈妈的世界知之甚少。我只知道她是我的妈妈，但我不知道她也是"小刘的烹饪伙伴"、"王姐的患难之交"、"李阿姨的逛街搭子"。</p>
<p>那天晚上，我把我的通讯录也重新整理了一遍。给每个人的备注后面，加上了我们认识的原因和年份。我想，当我老了的时候，翻看我的通讯录，也能像妈妈一样，看到自己的人生。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Close-up%20of%20an%20elderly%20Chinese%20woman%20looking%20at%20her%20smartphone%20with%20a%20gentle%20smile%2C%20warm%20indoor%20lighting%2C%20cozy%20home%20atmosphere%2C%20nostalgic%20mood%2C%20reflection%20and%20memory%2C%20soft%20focus%2C%20cinematic&width=1200&height=630&seq=article-cover-11&orientation=landscape',
    category: 'shenghuo-zhihui',
    author: '安然',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20avatar%20of%20a%20gentle%20Chinese%20woman%20illustration%2C%20warm%20tone%2C%20simple%20flat%20design%2C%20soft%20features&width=100&height=100&seq=avatar-02&orientation=squarish',
    date: '2024-08-28',
    readTime: '6分钟',
    tags: ['通讯录', '妈妈的故事', '人生感悟'],
    featured: false,
    hot: false,
  },
  {
    slug: 'mama-shi-guang-ji',
    title: '妈妈牌时光机：那些她帮姐妹守护的秘密',
    excerpt: '妈妈有一本特别的相册，里面不只有我们家的照片，还有很多阿姨们的照片和秘密。她就像一个温柔的时光守护者，替她所有的姐妹们保管着那些珍贵的记忆。',
    content: `<p>在我家的五斗柜最底层，有一本皮质封面的老相册。小时候我翻过一次，被妈妈制止了，说"那不是给你看的"。从此那本相册就成了我心中最大的谜团。</p>
<p>直到去年搬家，我帮妈妈整理东西，那本相册又出现了。这一次，妈妈主动打开了它。</p>
<p>原来，那不是一本普通的家庭相册。里面装着的，是妈妈和她的朋友们这些年来的"秘密"。</p>
<p>第一页夹着一张泛黄的电影票根。1985年3月12日，《芙蓉镇》。"这是阿怡的，"妈妈指着票根说，"那天她本来要和她老公去看电影，结果两个人吵架了。她就跑来找我，我们两个去看的。她一直没告诉她老公，说这是她的小报复。"</p>
<p>再翻一页，是一封信。字迹娟秀工整，落款是"秀兰"。"秀兰当年喜欢上了一个当兵的男孩，家里不同意，她就把信写好了托我保管。说如果有一天她走了，就把信寄出去。后来她没走，信也一直没寄。五十年了，这封信还在这里。"</p>
<p>还有一张褪色的彩照。照片上一个年轻女人穿着碎花裙子，站在油菜花田里回眸一笑。"这是王姐二十八岁的时候，她觉得自己这辈子最漂亮的就是这张照片。她说放在自己家里不放心，怕老公乱翻，就存在我这里。二十年了。"</p>
<p>相册里还有干枯的花瓣、折成心形的糖纸、一张褪色的演唱会门票、一块绣了一半的手帕……每一样东西，都是一段故事。而这些故事的共同点就是——它们的"保管人"，都是妈妈。</p>
<p>"你妈妈是我们这群人里最细心的，"记得有一次周阿姨来我家做客，对我说，"什么东西交给她保管，一百个放心。连我们年轻时候说的那些傻话、做的那些傻事，她都帮你记得清清楚楚的。"</p>
<p>妈妈听到夸奖，只是腼腆地笑笑，说："都是小事，不值得说。"</p>
<p>但我知道，这不是小事。这是信任，是情谊，是一个女人愿意为她的朋友们守护一生秘密的承诺。</p>
<p>那天下午，阳光透过窗户洒在相册上。八十多页的相册，每一页都沉甸甸的。我想，如果有一天能把这些故事都写出来，一定是这世界上最动人的书。不是因为情节有多曲折，而是因为每一页都写满了人与人之间最珍贵的东西——信任。</p>
<p>妈妈，我的朋友不多，但如果有一天我也能找到愿意把秘密交给我保管的人，那一定是因为你教会了我——什么是真正的朋友。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=An%20old%20leather%20photo%20album%20open%20on%20a%20wooden%20table%2C%20filled%20with%20old%20photos%20and%20mementos%2C%20warm%20afternoon%20sunlight%2C%20nostalgic%20atmosphere%2C%20memories%20and%20friendship%2C%20vintage%20aesthetic%2C%20soft%20warm%20tones%2C%20cinematic&width=1200&height=630&seq=article-cover-12&orientation=landscape',
    category: 'mama-yu-guimi',
    author: '雨桐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20avatar%20of%20a%20warm%20Chinese%20girl%20illustration%2C%20round%20face%2C%20gentle%20smile%2C%20soft%20colors%2C%20simple%20flat%20design&width=100&height=100&seq=avatar-03&orientation=squarish',
    date: '2024-08-12',
    readTime: '6分钟',
    tags: ['时光相册', '守护秘密', '女性友情'],
    featured: false,
    hot: false,
  },
];

export type Article = typeof articles[number];